<footer class="gb-footer footer-x">
  <div class="container-x">
    <div class="footer-grid">
      <div class="footer-brand">
        <a class="inline-block" [routerLink]="AppRoutes.home()" aria-label="GiveBrite home">
          <img class="footer-logo" [src]="platformLogoSrc" alt="givebrite" />
        </a>
        <p>
          The fundraising platform for faith-led giving — trusted by 900+ charities to turn
          generosity into instant relief.
        </p>
        <div class="socials">
          <a
            href="https://www.instagram.com/givebrite/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            ><svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <rect x="2.5" y="2.5" width="19" height="19" rx="5" />
              <circle cx="12" cy="12" r="4.5" />
              <circle cx="17.6" cy="6.4" r="1.1" fill="currentColor" stroke="none" /></svg
          ></a>
          <a
            href="https://www.facebook.com/givebrite/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            ><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.7c0-.9.3-1.6 1.7-1.6h1.5V4.2c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.7H7.8V14h2.7v8h3Z"
              /></svg
          ></a>
          <a
            href="https://www.linkedin.com/company/givebrite/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            ><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M6.5 8.8H3.2V21h3.3V8.8ZM4.9 7.4a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM21 13.6c0-3.2-1.7-4.7-4-4.7-1.8 0-2.7 1-3.2 1.8V8.8h-3.3V21h3.3v-6.3c0-1.7.8-2.7 2.2-2.7 1.3 0 1.9.9 1.9 2.7V21H21v-7.4Z"
              /></svg
          ></a>
        </div>
      </div>
      <div class="footer-col">
        <h4>For Charities</h4>
        <a [routerLink]="NavLinks.charitySignup.path">{{ NavLinks.charitySignup.label }}</a>
        <a [routerLink]="NavLinks.gbx.path">{{ NavLinks.gbx.label }}</a>
        <a [href]="NavLinks.charityDashboard.path" target="_blank" rel="noopener noreferrer">{{
          NavLinks.charityDashboard.label
        }}</a>
      </div>
      <div class="footer-col">
        <h4>For Fundraisers</h4>
        <a [routerLink]="NavLinks.discover.path">{{ NavLinks.discover.label }}</a>
      </div>
      <div class="footer-col">
        <h4>About Us</h4>
        <a [routerLink]="NavLinks.pricing.path">{{ NavLinks.pricing.label }}</a>
        <a [routerLink]="NavLinks.support.path">{{ NavLinks.support.label }}</a>
        <a [routerLink]="NavLinks.howItWorks.path">{{ NavLinks.howItWorks.label }}</a>
      </div>
    </div>
    <!-- Platform comparisons -->
    <div class="footer-col mb-[60px]">
      <h4>Compare Givebrite</h4>
      <div class="grid grid-cols-2 gap-x-14 sm:grid-cols-3 lg:grid-cols-4">
        @for (compareLink of CompareLinks; track compareLink.path) {
          <a [routerLink]="compareLink.path">{{ compareLink.label }}</a>
        }
      </div>
    </div>
    <div class="footer-bottom">
      <span>&copy; GiveBrite {{ year }} &middot; Company number 10023561</span>
      <span class="legal"
        ><a [routerLink]="NavLinks.terms.path">{{ NavLinks.terms.label }}</a
        ><a [routerLink]="NavLinks.privacy.path">{{ NavLinks.privacy.label }}</a></span
      >
    </div>
  </div>
</footer>
